import { render, staticRenderFns } from "./MeetingSidebar.vue?vue&type=template&id=6af6b166&scoped=true&"
import script from "./MeetingSidebar.vue?vue&type=script&lang=js&"
export * from "./MeetingSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MeetingSidebar.vue?vue&type=style&index=0&id=6af6b166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af6b166",
  null
  
)

export default component.exports